import { Dispatch } from 'react';
import {
    TServiceClientActionTypes,
    TCreateServiceClientVehicleServiceHistoryPayload,
} from '../types';
import { TFunction } from 'i18next';
import { VariantType } from 'notistack';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { UPDATE_SERVICE_CLIENT } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';

export type TCreateServiceClientVehicleServiceHistoryDeps = {
    t: TFunction;
    customAlert: (
        message: string,
        variant?: VariantType,
        options?: Record<string, unknown>,
        actionUrl?: string,
        playSound?: boolean
    ) => void;
};

export const createServiceClientVehicleServiceHistory = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    serviceClientId: string,
    vehicleId: string,
    payload: TCreateServiceClientVehicleServiceHistoryPayload,
    deps: TCreateServiceClientVehicleServiceHistoryDeps
): Promise<boolean | undefined> => {
    const { t, customAlert } = deps;

    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.post(
            `/service-clients/${serviceClientId}/vehicle/${vehicleId}/service-history/create`,
            payload,
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        dispatch({
            type: UPDATE_SERVICE_CLIENT,
            payload: res.data.data,
        });

        customAlert(t('SnackBar.ServiceClientUpdated'), 'success');

        return true;
    } catch (error) {
        if (error instanceof Error)
            dispatch(
                handleError(error, (message) =>
                    customAlert(message, 'error')
                )
            );
    }
};
